/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

class ProductForm extends HTMLElement {
    #boundSubmit;
    #eventAttached;
    #isSubmitting=false;
    static #formsBeingProcessed=new Set;
    static #redirectBatchFailed=false;
    constructor() {
        super();
        this.#boundSubmit = this.submit.bind(this);
    }
    connectedCallback() {
        this.#eventAttached = false;
        setTimeout((() => {
            this.form = this.querySelector("form");
            this.idInput = this.form.querySelector('input[name="id"]');
            this.submitButton = this.form.elements.add;
            this.stagedAction = this.querySelector("staged-action");
            this.idInput.removeAttribute("disabled");
            this.notifyOnAdd = this.hasAttribute("notify-on-add");
            this.redirectOnAdd = this.getAttribute("redirect-on-add");
            this.#eventAttached = true;
            this.form.addEventListener("submit", this.#boundSubmit);
        }));
    }
    disconnectedCallback() {
        if (this.#eventAttached) {
            this.#eventAttached = false;
            this.form.removeEventListener("submit", this.#boundSubmit);
        }
    }
    async submit(e) {
        e.preventDefault();
        if (this.#isSubmitting) return;
        this.#isSubmitting = true;
        const submitButton = e.submitter?.name === "add" ? e.submitter : this.submitButton;
        const submitButtonWasDisabled = submitButton?.disabled;
        const previousAriaBusy = this.getAttribute("aria-busy");
        const redirectOnAdd = this.redirectOnAdd;
        const formProcessingToken = redirectOnAdd ? {} : null;
        let addSucceeded = false;
        let shouldRedirect = false;
        if (submitButton) submitButton.disabled = true;
        this.setAttribute("aria-busy", "true");
        if (formProcessingToken) {
            if (ProductForm.#formsBeingProcessed.size === 0) ProductForm.#redirectBatchFailed = false;
            ProductForm.#formsBeingProcessed.add(formProcessingToken);
        }
        try {
            const data = new FormData(e.target);
            const item = Object.fromEntries(data.entries());
            this.removeError();
            if (this.stagedAction) await this.stagedAction.setState("DOING");
            await Cart.add(item);
            addSucceeded = true;
            if (redirectOnAdd) {
                if (this.stagedAction) await this.stagedAction.setState("IDLE");
            } else {
                if (this.stagedAction) await this.stagedAction.setState("DONE");
                const quickShop = this.closest("quick-shop");
                if (quickShop) {
                    await quickShop.close();
                }
                if (this.notifyOnAdd) {
                    await Cart.resetVariantsBeingAdded();
                    if (!this.closest(".modal--cart")) {
                        const cart = document.querySelector(".modal--cart, .popup--cart-notification");
                        if (cart && !cart.shown) {
                            cart.open();
                        } else if (cart && cart.interval) {
                            cart.interval.reset();
                            cart.interval.start();
                        }
                    }
                } else {
                    await Cart.resetLatestAddedProduct();
                    await Cart.resetVariantsBeingAdded(item.id);
                }
            }
        } catch (error) {
            if (!addSucceeded) this.#renderError(error.message);
            if (this.stagedAction) await this.stagedAction.setState("IDLE");
        } finally {
            if (formProcessingToken) {
                if (!addSucceeded) ProductForm.#redirectBatchFailed = true;
                ProductForm.#formsBeingProcessed.delete(formProcessingToken);
                if (ProductForm.#formsBeingProcessed.size === 0) {
                    shouldRedirect = !ProductForm.#redirectBatchFailed;
                    ProductForm.#redirectBatchFailed = false;
                }
            }
            this.#isSubmitting = false;
            if (submitButton) submitButton.disabled = submitButtonWasDisabled;
            if (previousAriaBusy === null) {
                this.removeAttribute("aria-busy");
            } else {
                this.setAttribute("aria-busy", previousAriaBusy);
            }
        }
        if (shouldRedirect) window.location.href = redirectOnAdd;
    }
    removeError() {
        const error = this.querySelector(".errors");
        if (!error) return;
        error.remove();
    }
    #renderError(message) {
        this.removeError();
        if (this.submitButton) {
            const error = document.createElement("div");
            error.classList.add("errors", "qty-error", "u-small");
            error.innerHTML = message;
            this.submitButton.before(error);
        }
    }
}

customElements.define("product-form", ProductForm);
//# sourceMappingURL=product-form.js.map
